import { CSSProperties } from "@material-ui/core/styles/withStyles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { CHROME_MAX_WIDTH } from "@components/chrome-wrapper/ChromeWrapper.styles";

// VIEW MODE
export const viewModeContainer: CSSProperties = {
  paddingTop: spacing.std,
  paddingBottom: spacing.std,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const people = {
  style: {
    marginRight: spacing.sm,
    width: 20,
    flexShrink: 0,
    alignSelf: "flex-start",
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const attendeeList = {
  fontSize: 14,
  color: greys.standard,
  flexGrow: 3,
};

export const icon = {
  htmlColor: greys.slate,
};

export const edit = {
  style: {
    right: 0,
    marginTop: -15,
    marginBottom: -15,
  } as CSSProperties,
};

// EDIT MODE
export const editModeContainer: CSSProperties = {
  height: "100%",
  width: "100%",
  position: "absolute",
  overflowY: "scroll",
  zIndex: 2,
  top: 0,
  left: 0,
  backgroundColor: greys.white,
  padding: `${spacing.sm}px 0 ${spacing.sm}px ${spacing.sm}px`,
};

export const closeIcon = {
  style: {
    right: 0,
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const header: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const title: CSSProperties = {
  color: colors.blueDusk.standard,
  fontWeight: "bold",
  fontSize: 20,
  marginTop: 1,
  marginLeft: 0,
  marginBottom: 0,
  marginRight: "auto",
};

export const primaryBtn: CSSProperties = {
  background: colors.green.standard,
  boxShadow: "none",
};

export const buttonContainer: CSSProperties = {
  position: "fixed",
  width: CHROME_MAX_WIDTH,
  bottom: 0,
  zIndex: 1,
  background: greys.white,
  marginLeft: -10,
  padding: `${spacing.std}px ${spacing.sm}px ${spacing.std}px ${spacing.sm}px`,
  boxShadow: "rgba(0, 0, 0, 0.25) 0px 0px 1px",
};

export const styles = {
  primaryBtn,
};
